<template>
  <div class="tool-bar">
    <el-form :inline="true" :model="form" size="mini">

      <slot name="simple-search">
        <el-form-item :label="searchLabel?searchLabel:'关键字'" v-if="operation && operation.search">
          <el-input placeholder="关键字" size="mini" v-model="form.Keyword" clearable></el-input>
        </el-form-item>
      </slot>
      <el-button-group style="padding-top: 0px">
        <el-button type="primary" @click="allSearch()" size="mini" icon="el-icon-search" v-if="operation && operation.search"> 搜索
        </el-button>
        <el-button @click="drawer = true" size="mini" type="primary"  icon="el-icon-monitor"
          v-if="operation && operation.advancedSearch"> 高级搜索
        </el-button>
        <el-button type="success" @click="onAdd()" size="mini" icon="el-icon-plus"
                  v-if="operation && operation.add"> 添加
        </el-button>
        <el-button type="success" @click="onAddqd()" size="mini" icon="el-icon-plus"
                   v-if="operation && operation.addqd"> 裂解空单建仓
        </el-button>
        <el-button type="success" @click="onAddztf()" size="mini" icon="el-icon-plus"
                   v-if="operation && operation.addztf"> 添加自销到代销
        </el-button>
        <el-button type="success" @click="onAddftz()" size="mini" icon="el-icon-plus"
                   v-if="operation && operation.addftz"> 添加代销到自销
        </el-button>
        <el-button type="danger" @click="onDelete()" size="mini" icon="el-icon-close"
                  v-if="operation && operation.delete"> 批量删除
        </el-button>
        <ty-import name="导入" :upload="uploadUrl" v-if="operation && operation.import" @uploaded="onUploaded" @beforeUpload = "beforeUpload">
        </ty-import>
        <el-button type="info" @click="onExport()" size="mini" icon="el-icon-download"
                  v-if="operation && operation.export"> 导出
        </el-button>
        <slot name="buttons"></slot>
      </el-button-group>

      <el-alert v-if="message" class="warning-message" :title="message" type="warning"></el-alert>
    </el-form>

    <!-- 高级搜索弹出层 -->
    <el-drawer v-if="operation && operation.advancedSearch"
      title="条件筛选" size="400px"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      :wrapperClosable="true"
      custom-class="demo-drawer"
      ref="drawer">
      <div class="demo-drawer__content advanced_search" style="height:100%;">
        <el-scrollbar>
          <el-form :model="form" label-position="left">
            <slot>
              <el-form-item label="关键字" v-if="operation && operation.search">
                <el-input placeholder="关键字" size="medium" v-model="form.Keyword" clearable></el-input>
              </el-form-item>
            </slot>
          </el-form>
        </el-scrollbar>
        <div class="demo-drawer__footer">
          <el-button type="primary" @click="allSearch()" icon="el-icon-search" style="width: 100%;"> 搜索
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  /**
   * @description 操作栏组件
   * @author tyx
   * @example 使用方式
   * <tool-bar :operation="{ add:true, search: true }" @add="onAdd()" @search="onSearch()">
   *
   *   <!-- 这里放 el-form-item -->
   *   <el-form-item label="关键字">
   *     <el-input placeholder="关键字" size="medium"></el-input>
   *   </el-form-item>
   *
   * </tool-bar>
   * @param operation 需要的按钮，仅支持 { search: true, add: true, delete: true, import: true, export: true }
   * @param form 筛选条件
   * @param message 提示信息
   * @event search 点击查询按钮触发
   * @event add 点击新增按钮触发
   * @event delete 点击删除按钮触发
   * @event import 点击导入按钮触发
   * @event export 点击导出按钮触发
   */
import TyImport from '@/tycomponents/Upload/TyImport'

export default {
  components: {
    TyImport
  },
  props: {
    operation: {
      type: Object
    },
    form: {
      type: Object
    },
    message: {
      type: String
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    screen: {
      type: Object,
      default: () => {
      }
    },
    searchLabel:{
      type: String,
    }
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl', // 从什么方向弹出
      height:0,
      hasChange: false
    }
  },
  methods: {
    onSearch() {
      this.$emit('search');
    },
    allSearch() {
      this.drawer = false;
      this.$emit('search');
    },
    onAdd() {
      this.$emit('add');
    },
    onAddqd() {
      this.$emit('addqd');
    },
    onAddftz(){
      this.$emit('addftz');
    },
    onAddztf(){
      this.$emit('addztf');
    },
    onDelete() {
      this.$emit('delete');
    },
    beforeUpload() {
      this.$emit("beforeUpload");
    },
    onUploaded(res, file) {
      this.$emit("uploaded", res, file);
    },
    onExport() {
      this.$emit('export');
    },
    // 弹出层关闭
    handleClose(done) {
      if(this.hasChange) {
        this.allSearch();
      }
      else {
        this.drawer = false;
      }
    }
  },
  mounted(){
    this.height = document.documentElement.clientHeight || document.body.clientHeight -61 -64 +'px';
  },
  computed: {
    tableHeight() {
      // 计算 grid 高度 屏幕高度 - margin（20 * 2）- toolbar（50）- pages（32） - border（1 * 2）

      return this.screen.height -66 -61;
    }
  },
  watch: {
    form: {
      handler(newName, oldName) {
          this.hasChange = true;
      },
      deep: true
    },
    drawer(val) {
      if(val) {
        this.hasChange = false;
      }
    }
  }
}

</script>

<style scoped>
  .tool-bar {
    /*height: 50px;*/
    max-height: 200px;
    background: #FFF;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px #EBEEF5 solid;
    padding: 5px 10px;
  }

  .warning-message {
    display:inline;
  }
  .ogc-icon-font  {
    font-size: 12px;
  }

</style>
<style>
  .advanced_search .el-form-item{
    margin-bottom: 0;
  }
  .advanced_search .el-scrollbar__wrap{
    height: calc(100% + 21px);
  }
  .advanced_search .el-date-editor{
    width: 100% !important;
  }
  .tool-bar .el-form-item{
    margin-bottom: 5px !important;
  }
  /*.tool-bar .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{*/
    /*margin-bottom: 5px;*/
  /*}*/
  /* 抽屉弹框 */
  .el-drawer__header{
    text-align: center;
  }
  .el-drawer__body{
    padding: 10px 30px 30px;
  }
  .demo-drawer__footer{
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #ccc;
  }
  .el-drawer__header{
    padding-bottom: 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #ccc;
  }
  .demo-drawer__content{
    display: flex;
    flex-direction:column;
    height: 100%;
  }
  .demo-drawer__content form{
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/tycomponents/Grid/ToolBar.vue